import type {
  CollectGraphql,
  IncidentGraphql,
} from '~/types/graphql-backend-types/gql-types'
import { COLLECTS_QUERY_SINGLE } from '~/queries/collects'
import { isObjectEmpty } from '~/utils/object'

export const useCollectStore = defineStore('collect', () => {
  const { query } = useGqlMikro()
  const collect = ref<CollectGraphql>({} as CollectGraphql)
  const collectLoading = ref<boolean>(false)
  const { isAdmin } = storeToRefs(useAuthStore())

  const incidents = computed(() => {
    if (isObjectEmpty(collect.value))
      return []
    return collect.value?.incidents?.collection as IncidentGraphql[] ?? []
  })

  const incidentsPenalty = computed(() => {
    let total = 0
    incidents.value.forEach((incident) => {
      if (incident)
        total += incident.penaltyAmount ? incident.penaltyAmount : 0
    })
    return total
  })

  const transportPrice = computed(() => {
    return collect.value?.transportPrice
  })

  async function loadSingleCollect(id: string) {
    if (!id)
      return

    collectLoading.value = true
    const { data, errors } = await query({
      query: COLLECTS_QUERY_SINGLE,
      variables: {
        pagination: {},
        filters: { ids: [id] },
        isAdmin: isAdmin.value,
      },
    })

    if (errors && errors.length > 0) {
      throw errors
    }

    collectLoading.value = false
    collect.value = JSON.parse(JSON.stringify(data.collects.collection[0]))
    collect.value.startsAt = new Date(collect.value.startsAt).toISOString()
    return collect.value
  }

  return {
    collect,
    collectLoading,
    incidents,
    incidentsPenalty,
    transportPrice,
    loadSingleCollect,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCollectStore, import.meta.hot))
}
